
<!--Enquiry form -->
<div class="main-register-wrap modal-inq">
    <div class="inq-overlay"></div>
    <div class="main-lg-holder model-lg tabs-act">
        <div class="main-register fl-wrap modal_main vis_mr">
            <div class="main-register_title"> Tell us about your requirement</div>
            <div class="close-reg"><i class="fal fa-times"></i></div>
            <div class="model-padd">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="listing-item-grid" title="Click on a title">
                            <div class="bg" data-bg="../../assets/images/premium_ads/farm-fresh-ads-1.jpg"
                                style="background-image: url(&quot;../../assets/images/premium_ads/farm-fresh-ads-1.jpg&quot;);">
                            </div>
                            <div class="d-gr-sec"></div>
                            <div class="listing-counter color2-bg"><span><i class="fas fa-map-marker-alt"></i> SP
                                    Infocity, Pune, </span> Maharashtra</div>
                            <div class="listing-item-grid_title">
                                <h3><a href="/business-info"> Farm Fresh Mart</a></h3>
                                <p>Constant care and attention to the patients makes good record</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="custom-form tabs-container">
                            <app-send-enquiry></app-send-enquiry>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- Enquiry form end -->

<a class="to-top"><i class="fas fa-caret-up"></i></a>